/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import "./index.less";
import ShareHintCard from "./ShareHintCard";
import ChatState from "@/types/chat/State";
import { getTextMessageRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function ShareHintCardList(props: any) {
  const { currentEmployee, selectedSession, message, sessionType, sendType, onReady } = props;
  return (
    <div className="content">
      <div className="card-container-app other share-hint">
        <div
          className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
          dangerouslySetInnerHTML={{
            __html: getTextMessageRemark(selectedSession, message, currentEmployee, "", -1).trim()
          }}
        />
        <div className="card-wrap showMore">
          {message.data?.map((d: any, idx: number) => {
            return (
              <ShareHintCard
                sendType={sendType}
                onReady={onReady}
                message={{ ...message, data: [d] }}
                sessionType={sessionType}
                key={`${message.id}_${idx}`}
                clsName="small-card"
                showFooter={false}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareHintCardList);
